import React, { useEffect, useState } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";
import { useParams } from "react-router-dom";
import useAxios from "../../../Utils/useAxios";

const PDFViewerComponentTandaDiterima = () => {
  const { formId } = useParams();
  const axiosInstance = useAxios();
  const [groupDokumenTransaksi, setGroupDokumenTransaksi] = useState(null);
  const [unitKerjaList, setUnitKerjaList] = useState([]);
  const [transaksiList, setTransaksiList] = useState([]);

  useEffect(() => {
    getGroupDokumenTransaksi();
    getUnitKerja();
  }, []);

  const getGroupDokumenTransaksi = async () => {
    axiosInstance
      .get(`groupdokumentransaksi/${formId}`)
      .then((response) => {
        setGroupDokumenTransaksi(response.data);
        getTransaksi(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getUnitKerja = async () => {
    try {
      const response = await axiosInstance.get("unitkerja/");
      if (response.status === 200) {
        setUnitKerjaList(response.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getTransaksi = async (groupDokumenTransaksi) => {
    await axiosInstance
      .get(`group-transaksi-list/` + groupDokumenTransaksi.group_transaksi)
      .then((res) => {
        setTransaksiList(res.data);
      });
  };

  return (
    <PDFViewer width="1444" height="1444">
      <MyDocument
        groupDokumenTransaksi={groupDokumenTransaksi}
        unitKerjaList={unitKerjaList}
        transaksiList={transaksiList}
      />
    </PDFViewer>
  );
};

export default PDFViewerComponentTandaDiterima;
